/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionInviteStatsPageItemVo } from './CommissionInviteStatsPageItemVo';
import {
    CommissionInviteStatsPageItemVoFromJSON,
    CommissionInviteStatsPageItemVoFromJSONTyped,
    CommissionInviteStatsPageItemVoToJSON,
    CommissionInviteStatsPageItemVoToJSONTyped,
} from './CommissionInviteStatsPageItemVo';

/**
 * 
 * @export
 * @interface PageDataCommissionInviteStatsPageItemVo
 */
export interface PageDataCommissionInviteStatsPageItemVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataCommissionInviteStatsPageItemVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataCommissionInviteStatsPageItemVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataCommissionInviteStatsPageItemVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<CommissionInviteStatsPageItemVo>}
     * @memberof PageDataCommissionInviteStatsPageItemVo
     */
    records?: Array<CommissionInviteStatsPageItemVo>;
}

/**
 * Check if a given object implements the PageDataCommissionInviteStatsPageItemVo interface.
 */
export function instanceOfPageDataCommissionInviteStatsPageItemVo(value: object): value is PageDataCommissionInviteStatsPageItemVo {
    return true;
}

export function PageDataCommissionInviteStatsPageItemVoFromJSON(json: any): PageDataCommissionInviteStatsPageItemVo {
    return PageDataCommissionInviteStatsPageItemVoFromJSONTyped(json, false);
}

export function PageDataCommissionInviteStatsPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataCommissionInviteStatsPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(CommissionInviteStatsPageItemVoFromJSON)),
    };
}

export function PageDataCommissionInviteStatsPageItemVoToJSON(json: any): PageDataCommissionInviteStatsPageItemVo {
    return PageDataCommissionInviteStatsPageItemVoToJSONTyped(json, false);
}

export function PageDataCommissionInviteStatsPageItemVoToJSONTyped(value?: PageDataCommissionInviteStatsPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(CommissionInviteStatsPageItemVoToJSON)),
    };
}

